export const treeStructure = [
  {
    id: 'b1',
    direction: 'left',
    branchNum: 1,
    leaves: [4, 5, 6],
    flowerId: 'f5',
    innerBranches: [
      {
        id: 'b2',
        direction: 'left',
        type: 'branch-inner1',
        leaves: [7, 8, 9],
        flowerId: 'f2'
      },
      {
        id: 'b3',
        direction: 'left',
        type: 'branch-inner2',
        leaves: [10, 11, 12],
        flowerId: 'f3'
      },
      {
        id: 'b4',
        direction: 'left',
        type: 'branch-inner3',
        leaves: [13, 14],
        flowerId: 'f4'
      }
    ]
  },
  {
    id: 'b5',
    direction: 'right',
    branchNum: 2,
    leaves: [15, 16, 17],
    flowerId: 'f10',
    innerBranches: [
      {
        id: 'b6',
        direction: 'left',
        type: 'branch-inner1',
        leaves: [18, 19, 20],
        flowerId: 'f6'
      },
      {
        id: 'b7',
        direction: 'right',
        type: 'branch-inner2',
        leaves: [21, 22, 23],
        flowerId: 'f7'
      },
      {
        id: 'b8',
        direction: 'right',
        type: 'branch-inner3',
        leaves: [24, 25, 26],
        flowerId: 'f9',
        subBranch: {
          id: 'b9',
          direction: 'left',
          type: 'branch-subinner',
          leaves: [27],
          flowerId: 'f8'
        }
      }
    ]
  },
  {
    id: 'b10',
    direction: 'left',
    branchNum: 3,
    leaves: [28, 29, 30],
    flowerId: 'f13',
    innerBranches: [
      {
        id: 'b11',
        direction: 'right',
        type: 'branch-inner1',
        leaves: [31, 32, 33],
        flowerId: 'f11'
      },
      {
        id: 'b12',
        direction: 'left',
        type: 'branch-inner2',
        leaves: [34, 35, 36],
        flowerId: 'f12'
      }
    ]
  },
  {
    id: 'b13',
    direction: 'right',
    branchNum: 4,
    leaves: [37, 38, 39],
    flowerId: 'f16',
    innerBranches: [
      {
        id: 'b14',
        direction: 'left',
        type: 'branch-inner1',
        leaves: [40, 41, 42],
        flowerId: 'f14'
      },
      {
        id: 'b15',
        direction: 'right',
        type: 'branch-inner2',
        leaves: [43, 44, 45],
        flowerId: 'f15'
      }
    ]
  },
  {
    id: 'b16',
    direction: 'left',
    branchNum: 5,
    leaves: [46, 47, 48],
    flowerId: 'f19',
    innerBranches: [
      {
        id: 'b17',
        direction: 'right',
        type: 'branch-inner1',
        leaves: [49, 50, 51],
        flowerId: 'f17'
      },
      {
        id: 'b18',
        direction: 'left',
        type: 'branch-inner2',
        leaves: [52, 53, 54],
        flowerId: 'f18'
      }
    ]
  }
];

// ============================================================================

export const UNTRANSCRIBED_THRESHOLD = 100;

export const BASE_MAIN_BRANCHES = 5;        // Number of main branches in treeStructure
export const BASE_BRANCHES = 18;            // Total branch elements (including inner branches)
export const BASE_LEAVES = 54;              // Total leaves in base 5 branches
export const BASE_FLOWERS = 19;             // Total flowers in base 5 branches

// Growth configuration
export const MAX_BRANCH_COUNT = 5;          // ADJUSTABLE; Maximum total branches allowed (Changed to 5 from 12)
export const LEAVES_PER_MAIN_BRANCH = 9;    // Each main branch holds 9 leaves (3 main + 3+3 inner)
export const FLOWERS_PER_MAIN_BRANCH = 3;   // Each main branch holds 3 flowers (1 main + 1+1 inner)

// Tree dimensions and spacing
export const MAX_TRUNK_HEIGHT = 310;        // ADJUSTABLE; Maximum trunk height allowed (px)
export const BASE_TRUNK_HEIGHT = 310;       // Height needed for base 5 branches (px)
export const BRANCH_SPACING = 40;           // Vertical spacing per additional branch (px)
export const TOP_PADDING = 20;              // Extra padding at top of tree (px)
export const GROUND_HEIGHT = 55;            // Height of ground/grass at bottom (px)

const DEMO_FEATURES_STORAGE_KEY = 'demoFeaturesEnabled';
const hasDemoFeaturesInLocation = () => {
  if (new URLSearchParams(window.location.search).has('demoFeatures')) return true;
  const hash = window.location.hash || '';
  const qIndex = hash.indexOf('?');
  if (qIndex !== -1) {
    return new URLSearchParams(hash.slice(qIndex + 1)).has('demoFeatures');
  }
  return false;
};

export const captureDemoFeaturesParam = () => {
  if (typeof window === 'undefined') return;
  try {
    if (hasDemoFeaturesInLocation()) {
      window.sessionStorage.setItem(DEMO_FEATURES_STORAGE_KEY, '1');
    } else {
      window.sessionStorage.removeItem(DEMO_FEATURES_STORAGE_KEY);
    }
  } catch { /* ignore */ }
};
export const recaptureDemoFeaturesOnNavigation = () => {
  if (typeof window === 'undefined') return;
  try {
    if (hasDemoFeaturesInLocation()) {
      window.sessionStorage.setItem(DEMO_FEATURES_STORAGE_KEY, '1');
    }
  } catch { /* ignore */ }
};

export const hasDemoFeaturesParam = () => {
  if (typeof window === 'undefined') return false;

  if (hasDemoFeaturesInLocation()) return true;

  try {
    return window.sessionStorage.getItem(DEMO_FEATURES_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
};
export const DEV_MAX_BRANCH_COUNT = 10;
export const DEV_MAX_TRUNK_HEIGHT = 730;

// Visual scaling
export const TREE_SCALE = 0.6;              // ADJUSTABLE; Scale factor for display (60% of original)

// Reasonable tree settings are:
//   max branches: 5;  max trunk height: 310px
//   max branches: 8;  max trunk height: 450px
//   max branches: 10; max trunk height: 710px
//   max branches: 12; max trunk height: 650px
//   max branches: 15; max trunk height: 730px


// FLOWER COLORS BY TYPE
export const typeFlowerColors = {
  making_claim: 'blueflower',
  relating: 'yellowflower',
  providing_evidence: 'redflower',
  accuracy: 'blueflower',
  reasoning: 'redflower',
  students_relating: 'yellowflower'
};

export const TREE_GROWTH_CONFIG = {
  LEAVES_PER_BRANCH: 3,
  INNER_BRANCHES_PER_MAIN: 2,
  MIN_MAIN_BRANCHES: BASE_MAIN_BRANCHES,
  INFINITE_GROWTH: true
};

export const generateDynamicMainBranch = (
  mainBranchNum,
  startBranchId,
  startLeafNum,
  startFlowerId
) => {
  const isLeft = mainBranchNum % 2 === 1;
  const direction = isLeft ? 'left' : 'right';

  const mainBranchId = `b${startBranchId}`;
  const mainLeaves = [startLeafNum, startLeafNum + 1, startLeafNum + 2];
  const mainFlowerId = `f${startFlowerId + 2}`;

  const inner1Id = `b${startBranchId + 1}`;
  const inner1Leaves = [startLeafNum + 3, startLeafNum + 4, startLeafNum + 5];
  const inner1FlowerId = `f${startFlowerId}`;
  const inner1Direction = isLeft ? 'right' : 'left'; 

  const inner2Id = `b${startBranchId + 2}`;
  const inner2Leaves = [startLeafNum + 6, startLeafNum + 7, startLeafNum + 8];
  const inner2FlowerId = `f${startFlowerId + 1}`;
  const inner2Direction = direction;

  return {
    id: mainBranchId,
    direction,
    branchNum: mainBranchNum,
    leaves: mainLeaves,
    flowerId: mainFlowerId,
    isDynamic: true,
    innerBranches: [
      {
        id: inner1Id,
        direction: inner1Direction,
        type: 'branch-inner1',
        leaves: inner1Leaves,
        flowerId: inner1FlowerId,
        isDynamic: true
      },
      {
        id: inner2Id,
        direction: inner2Direction,
        type: 'branch-inner2',
        leaves: inner2Leaves,
        flowerId: inner2FlowerId,
        isDynamic: true
      }
    ]
  };
};

// Adds visibility flags to a branch based on total flowers and leaves
const addVisibilityFlags = (branch, totalFlowers, totalLeaves) => {
  const flowerNum = parseInt(branch.flowerId.replace('f', ''));
  branch.flowerVisible = flowerNum <= totalFlowers;

  branch.leaf1Visible = branch.leaves[0] <= totalLeaves;
  branch.leaf2Visible = branch.leaves[1] <= totalLeaves;
  branch.leaf3Visible = branch.leaves[2] ? branch.leaves[2] <= totalLeaves : false;

  const hasVisibleContent = branch.flowerVisible ||
    branch.leaf1Visible ||
    branch.leaf2Visible ||
    branch.leaf3Visible;

  let hasVisibleInnerBranch = false;

  if (branch.innerBranches) {
    branch.innerBranches = branch.innerBranches.map(inner => {
      const innerFlowerNum = parseInt(inner.flowerId.replace('f', ''));

      const processedInner = {
        ...inner,
        flowerVisible: innerFlowerNum <= totalFlowers,
        leaf1Visible: inner.leaves[0] <= totalLeaves,
        leaf2Visible: inner.leaves[1] <= totalLeaves,
        leaf3Visible: inner.leaves[2] ? inner.leaves[2] <= totalLeaves : false
      };

      const innerHasContent = processedInner.flowerVisible ||
        processedInner.leaf1Visible ||
        processedInner.leaf2Visible ||
        processedInner.leaf3Visible;

      processedInner.visible = innerHasContent;

      if (inner.subBranch) {
        const subFlowerNum = parseInt(inner.subBranch.flowerId.replace('f', ''));
        const subLeafVisible = inner.subBranch.leaves[0] <= totalLeaves;
        const subFlowerVisible = subFlowerNum <= totalFlowers;

        processedInner.subBranch = {
          ...inner.subBranch,
          flowerVisible: subFlowerVisible,
          leaf1Visible: subLeafVisible,
          visible: subFlowerVisible || subLeafVisible
        };

        if (processedInner.subBranch.visible) {
          processedInner.visible = true;
        }
      }

      if (processedInner.visible) {
        hasVisibleInnerBranch = true;
      }

      return processedInner;
    });
  }

  // Main branch is visible if it has content OR any inner branches are visible
  branch.visible = hasVisibleContent || hasVisibleInnerBranch;

  return branch;
};

export const calculateRequiredBranches = (totalLeaves, totalFlowers, maxBranchCountOverride = MAX_BRANCH_COUNT) => {
  // Calculate branches needed for leaves
  // First BASE_MAIN_BRANCHES hold BASE_LEAVES leaves
  // Each additional branch holds LEAVES_PER_MAIN_BRANCH leaves
  let potentialLeafBranchCount = BASE_MAIN_BRANCHES;
  if (totalLeaves > BASE_LEAVES) {
    const additionalLeaves = totalLeaves - BASE_LEAVES;
    const additionalBranches = Math.ceil(additionalLeaves / LEAVES_PER_MAIN_BRANCH);
    potentialLeafBranchCount = BASE_MAIN_BRANCHES + additionalBranches;
  }

  // Calculate branches needed for flowers
  // First BASE_MAIN_BRANCHES hold BASE_FLOWERS flowers
  // Each additional branch holds FLOWERS_PER_MAIN_BRANCH flowers
  let potentialFlowerBranchCount = BASE_MAIN_BRANCHES;
  if (totalFlowers > BASE_FLOWERS) {
    const additionalFlowers = totalFlowers - BASE_FLOWERS;
    const additionalBranches = Math.ceil(additionalFlowers / FLOWERS_PER_MAIN_BRANCH);
    potentialFlowerBranchCount = BASE_MAIN_BRANCHES + additionalBranches;
  }

  const branchCount = Math.min(
    maxBranchCountOverride,
    Math.max(potentialLeafBranchCount, potentialFlowerBranchCount)
  );

  return {
    branchCount,
    potentialLeafBranchCount,
    potentialFlowerBranchCount,
    isLeafLimited: potentialLeafBranchCount >= potentialFlowerBranchCount,
    isCapped: branchCount === maxBranchCountOverride
  };
};


 // Generates the complete tree structure based on branch count
export const generateCompleteTreeStructure = (totalFlowers, totalLeaves, branchCount) => {
  // Process base branches with visibility flags
  const complete = treeStructure.map(branch =>
    addVisibilityFlags({ ...branch }, totalFlowers, totalLeaves)
  );

  // If we only need the base branches
  if (branchCount <= BASE_MAIN_BRANCHES) {
    return {
      branches: complete,
      isHeightCapped: false,
      displayedFlowers: totalFlowers,
      totalFlowers: totalFlowers,
      branchCount: BASE_MAIN_BRANCHES
    };
  }

  // Calculate how many dynamic branches we need beyond the base
  const dynamicBranchesNeeded = branchCount - BASE_MAIN_BRANCHES;

  let currentBranchId = BASE_BRANCHES + 1;
  let currentLeafNum = BASE_LEAVES + 1;
  let currentFlowerId = BASE_FLOWERS + 1;

  // Add dynamic branches
  for (let i = 0; i < dynamicBranchesNeeded; i++) {
    const mainBranchNum = (BASE_MAIN_BRANCHES + 1) + i;  // Start at 6
    const newBranch = generateDynamicMainBranch(
      mainBranchNum,
      currentBranchId,
      currentLeafNum,
      currentFlowerId
    );

    // Set visibility for the new branch
    newBranch.visible = true;
    const mainFlowerNum = parseInt(newBranch.flowerId.replace('f', ''));
    newBranch.flowerVisible = mainFlowerNum <= totalFlowers;
    newBranch.leaf1Visible = currentLeafNum <= totalLeaves;
    newBranch.leaf2Visible = (currentLeafNum + 1) <= totalLeaves;
    newBranch.leaf3Visible = (currentLeafNum + 2) <= totalLeaves;

    // Set visibility for inner branches
    newBranch.innerBranches = newBranch.innerBranches.map(inner => {
      const innerFlowerNum = parseInt(inner.flowerId.replace('f', ''));
      return {
        ...inner,
        visible: innerFlowerNum <= totalFlowers || inner.leaves.some(l => l <= totalLeaves),
        flowerVisible: innerFlowerNum <= totalFlowers,
        leaf1Visible: inner.leaves[0] <= totalLeaves,
        leaf2Visible: inner.leaves[1] <= totalLeaves,
        leaf3Visible: inner.leaves[2] <= totalLeaves
      };
    });

    complete.push(newBranch);

    // Increment counters for next branch
    currentBranchId += 3;  // Each main branch uses 3 IDs (1 main + 2 inner)
    currentLeafNum += LEAVES_PER_MAIN_BRANCH;
    currentFlowerId += FLOWERS_PER_MAIN_BRANCH;
  }

  return {
    branches: complete,
    isHeightCapped: branchCount === MAX_BRANCH_COUNT,
    displayedFlowers: totalFlowers,
    totalFlowers: totalFlowers,
    branchCount: branchCount
  };
};


export const calculateTreeDimensions = (branchCount, maxTrunkHeightOverride = MAX_TRUNK_HEIGHT) => {
  // Ensure we have at least base branches
  const actualBranchCount = Math.max(BASE_MAIN_BRANCHES, branchCount);
  
  // Calculate additional branches beyond base
  const additionalBranches = Math.max(0, actualBranchCount - BASE_MAIN_BRANCHES);
  
  // Calculate total height: base + (additional branches × spacing) + padding
  const calculatedHeight = BASE_TRUNK_HEIGHT + (additionalBranches * BRANCH_SPACING) + TOP_PADDING;
  
  // Cap at maximum height
  const trunkHeight = Math.min(maxTrunkHeightOverride, calculatedHeight);
  
  // Add ground height for total background
  const backgroundHeight = trunkHeight + GROUND_HEIGHT;

  // console.log(`Calculated tree dimensions for ${branchCount} branches: trunkHeight=${trunkHeight}, backgroundHeight=${backgroundHeight}`);

  return {
    trunkHeight: Math.round(trunkHeight),
    backgroundHeight: Math.round(backgroundHeight),
    branchCount: actualBranchCount,
    scalingMethod: 'branch-based'
  };
};

export const calculateMaxBranchesForTrunk = (trunkHeight) => {
  const availableSpace = trunkHeight - BASE_TRUNK_HEIGHT;
  const maxDynamicBranches = Math.floor(availableSpace / BRANCH_SPACING);
  const maxTotalMainBranches = BASE_MAIN_BRANCHES + maxDynamicBranches;
  
  return {
    maxDynamicBranches,
    maxTotalMainBranches,
    availableSpace
  };
};

// CSS STYLING FUNCTIONS


export const getDynamicInnerBranchStyles = (type, parentDirection) => {
  const isLeftParent = parentDirection === 'left';

  if (type === 'branch-inner1') {
    if (isLeftParent) {
      return {
        width: '40%',
        height: '95%',
        left: '33%',
        top: '-5%',
        transform: 'rotate(35deg)',
        transformOrigin: '0% 100%'
      };
    } else {
      return {
        width: '52%',
        height: '184%',
        left: '-23%',
        top: '-34%',
        transform: 'rotate(90deg)',
        transformOrigin: '0% 100%'
      };
    }
  }

  if (type === 'branch-inner2') {
    if (isLeftParent) {
      return {
        width: '40%',
        height: '40%',
        left: '17%',
        top: '33%',
        transform: 'rotate(-30deg)',
        transformOrigin: '0% 100%'
      };
    } else {
      return {
        width: '52%',
        height: '210%',
        left: '48%',
        top: '-68%',
        transform: 'rotate(60deg)',
        transformOrigin: '100% 100%'
      };
    }
  }

  return {};
};


export const getDynamicBranchStyles = (branchNum, trunkHeight) => {
  // Only apply to dynamic branches beyond the base
  if (branchNum <= BASE_MAIN_BRANCHES) return null;

  const branchesFromBase = branchNum - BASE_MAIN_BRANCHES;

  // Calculate cumulative spacing from base
  const cumulativeSpacing = branchesFromBase * BRANCH_SPACING;

  // Calculate position from bottom
  const distanceFromBottom = BASE_TRUNK_HEIGHT + cumulativeSpacing;
  const topPosition = trunkHeight - distanceFromBottom;
  const widthScaleFactor = Math.max(0.50, 1 - (branchesFromBase * 0.03));
  const baseWidth = branchNum % 2 === 1 ? 100 : 110;
  const baseHeight = Math.max(25, 40 - (branchesFromBase * 2));
  const width = Math.max(60, Math.floor(baseWidth * widthScaleFactor));
  const height = Math.max(22, baseHeight);
  const currentSpacing = 50 + (branchesFromBase * 3);

  return {
    top: `${topPosition}px`,
    width: `${width}px`,
    height: `${height}px`,
    '--branch-num': branchNum,
    '--trunk-height': `${trunkHeight}px`,
    '--branch-spacing': `${currentSpacing}px`,
    '--width-scale': widthScaleFactor,
    '--cumulative-spacing': `${cumulativeSpacing}px`
  };
};

export const getDynamicSubInnerBranchStyles = (parentBranchNum, parentDirection) => {
  const isLeftParent = parentDirection === 'left';

  if (isLeftParent) {
    return {
      width: '30%',
      height: '25%',
      left: '10%',
      top: '50%',
      transform: 'rotate(40deg)',
      transformOrigin: '0% 100%'
    };
  } else {
    return {
      width: '33%',
      height: '19%',
      left: '0%',
      top: '10%',
      transform: 'rotate(180deg)',
      transformOrigin: '0% 100%',
      borderBottomLeftRadius: '100% 100%'
    };
  }
};

export const isDynamicBranch = (branchId) => {
  const branchNum = parseInt(branchId.replace('b', ''));
  return branchNum > BASE_BRANCHES;
};

export const isDynamicFlower = (flowerId) => {
  const flowerNum = parseInt(flowerId.replace('f', ''));
  return flowerNum > BASE_FLOWERS;
};

export const isDynamicLeaf = (leafNum) => {
  return leafNum > BASE_LEAVES;
};